export default ".selector {\n  background-color: red;\n}"